<template>
  <div class="overall-priceAd-starts">
    <div>
      <template v-for="(scoreType, index) in scoreTypes">
        <span
          :key="index"
          :class="scoreCls(scoreType)"
        ></span>
      </template>
    </div>
    <em>{{ score.toFixed(2) }}</em>
  </div>
</template>
<script>
const scoreTypeEnum = { 0: '', 1: 'half-full', 2: 'full' };
export default {
  props: {
    score: {
      type: Number,
      default: 0
    }
  },
  computed: {
    scoreCls () {
      return (scoreType) => {
        return scoreTypeEnum[scoreType];
      };
    },
    scoreTypes () {
      // 0 无 1 半 2 全
      const list = [0, 0, 0, 0, 0];
      const score = this.score;
      for (let index = 0; index < score; index++) {
        if (score <= index) {
          break;
        }
        else if (index < score && index + 1 > score) {
          list[index] = 1;
        }
        else if (index + 1 <= score) {
          list[index] = 2;
        }
      }
      return list;
    }
  }
};
</script>
<style lang="scss">
.overall-priceAd-starts {
  font-size: 0;
  white-space: nowrap;
  height: ptrd(36px);
  line-height: ptrd(36);
  // margin-left: ptrd(8px);
  overflow: hidden;
  flex-shrink: 0;
  div {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    vertical-align: middle;
    display: inline-block;
    width: ptrd(20);
    height: ptrd(20);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEoklEQVRoQ+1ZTWwUZRh+n9mWdmZFtDPbzuxBD1ITE0IUDSoeiODFHySiViXxJxIhPahHL+pBvXhUEqMQAjGmRqIkgMrFEj2ISPwLIfHQetDDzrQ7W39wZ0rbnceMWt3W3Z1vltkVEua43/M+7/N87+z3vvkGcpE/uMj1yyUD/3cFO1YBkr3T/uxIDQLH7B8DEHXCbMcMuH5wkOSDsWhA9jtW/smLxoDnBzdH5Ml6wRpwi20ZX2ZtoiMVcMvVjyhyV71YiHzsFPJ3X/AGSuXqjSLyVROhNxUL+a+zNJF5BVw/OEzy3kYiARxxLGPrBWtg+ue56xcW5r9tJbCnp/eGwStXfJeViUwr4PrBByS3tRIH4JBjGfdfcAa8mXNrGNVOk2y5KQAILbfWHug7k4WJzCrgloP3KBxREQXBQadgPKSCTcJkYqDkn7sOUjtDUktK+FdjQ0TJrSlafd+r4Fu+kudLEIv2/ODo8nM/iTfuC7ZlbDnfESN1BcplrmTP/OpatDBM4loIt5BcnyS4ybF6ioIjACdyWs8EFnonCwWcTcPV0IBH5vHL/OooWhgGMUyJYrHDEK6miJ0mQVosRDwKJmNTEG2C4ISm9Uzwit5JG6gu51tigKTuVsK9EHlE9X1OK7BdfHx6ichRmPr2eiNLDLh+dZSUN9pN0qW40WIh/+ZiriUGSuXqLhH5Z7FLgtKlgfZo0dLfaWiAZJ/rh+MivC0da7fQ+Nyx9I0Aag0NxD9Ok5fV/PBDCjd2S5ZKHgg+y1n6PYPA7/X4hqcQScOtBIeFcocKeccxkE8c09gKIGh5CtUvkuz3/OAQRe7suMAWCSByzLaMbQBmG/aSVuJIrnAr4UEhM53hlTcEOOyY+giAuWYxiZ04vl3wKuEYyQeUE2cABPC+berbAcy3oks0EAeTzLmV8G0ht2egLZkCGHNM/bH606btCiwG/jm0VYJ9pDyRrKB9BCAHbNPYoTrkKVWgzkTO84NvKLK2fYnNIyFy2raMdSo737QPJAkrlatvicjOJFyb63uKhXw8DSg/qSoQsza681HOlgBs5+4otYGSH/wo5FVZiV7CA/xUtIyr03CnMlCp8PJzUfBrmgRpsX2asco08ZtqXCoDU5Xg1lrEE6rk7eByGjYMmcYXqrGpDHiV8KkoivaokreD0zRtp23qe1VjUxko+cFrQj6jSt4WDni9aBnPqsamMuD6wTjJTark7eAAHHcsY7NqbDoD5eoURQaVyIETEMQ9QyjcJeQGlTiITDuF/JAKNsYoG/DOcjCaDaaSiONuCpHn7UL+aD3WK1e3UOQVlS6u9RtD9kpMJ+VKZ8APN0WMxpuRQvADRF4csvR3/75B+A80nqem/PBhirxE4TXNuDRom21LP56pAdcPHyejA8tJAZRIvuxYxr6k0XcxNh7RXT+IB7YXSBaXc6Y5iZRfIdcP1pP89xsXZAaCV21T3w0gVNmt5Zj4HsqrhE9T+JxQBhbXIdrtTkH/VIVT2UBM5lXCHYyi+wjtZL/Wv3tgAJl05ZkZrpqLZkcpXCfAMcfU96uIT/UfUCXsNi5VBbotTiXfJQMqu9RJzB9moLtAvwVmQQAAAABJRU5ErkJggg==);
    //  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADTklEQVRYR92XT2gUZxjG32c2jZlJCmZ3NtkZaWgLSy9qD1U8+acXg+baWwktgUKQ0kJL9aCBgHpoSxU9qCAoSo+tV7FQiO1NW5DSSwm0JaU7u+7sxkN2Zo0788huEnGTnT/Z2drgnHbne9/n+c37zfd+30C22IUtxiMvJ5BlOx8T0m+k1fMAmKTqiStklZ0vKPyqCQHghKFrrd/dXomAHpJDjYrzt1AyLQBIpS+jvT4CLP0vQJbtHCf55fPmSavUdYVIakXb+YsiI21AIg9zuvYGAKebKnUNVKg4n4nPbzqaKvjczGjnXhgQyYHV6uQ6mUKkuFql+mahuqpQ0XY+8ckLYWYK8GlO1y7+50CPHnHYbbi/kzTDzAAU1D515/btWNwMVGiFSG6zKstvKmzkKchDQd4njwg5FssEWFCA2/Q5D+G8j755I9P/J4DHQfltQFa1flR8f4LCPAR5ERkjqcQyjxkEwBeRBUoTEvMU+dHUtVtr6c+ASovLb3uNJw9i6vY0DKK8a2TVuZXeunoVq493+V7jt546xRQDsM/QtXttQM0/Bds9JfRPx9TpTRiUGVNXz2yYsrUbz2+WvXEMVoHguJHVvl7X6TcmxOkzSWGD+lTgsi+Ua9MALpHsqnkGLmuAJI+Z2cErAV0++FmLFXeK5NVeLf3mkgfwUS6jXovVhzoFFWx3UujfTDpFrXwok6aufhumFWs6rLIzR+HBJFAQ3DWy2qEojVhAhbLzkwj3R4mFj+NnM6sdiNKIB2TXqkIZjhILHYcsmvpgOkojEqhcrplPRP6NEooz/orIjmx2sJDoHSpV6oc937sTxzAqJqWkxkczAz8kAgo9qkYRrB+PcbSNnDLLrl0n5cOIp2ptyhTZHRoHuW7og1OJKmTZzn2SewJEfk0pqZOjmYHWlJYq9XHP986KyDsduzDwi6Fre7sGam4blu0uiVBrEwH+AGQml1a/W//p3MwpVt33SDkt5Fvt5nAMXR0K+9yOOsL2WRW3JmT/SqfFPwowO5oeuAHAC3tSkqlStf6BT84K+dpKOrxcRn0VgBuUG/kOlcru+55wWlHk+9G0ejnsPNzJpHkuL1XdaZ+cEFFu9mTr2OxiShIfWaEk4t3kbjmgp4u/RzT3KtUJAAAAAElFTkSuQmCC);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;

    &.full {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAByklEQVQ4T6WUz0tUURTHP9+ZsEAQwsratNMKcuFCEhIUxIRcuDCMWrR8M4rtXQiOENEfIOObt46QqEWLAn9BgYHiwoVCRbgRoghEEFwozZyY5yjjOL531QsHLvd+v597uPfcIxyHeYwACQW8dLHIRWRp7lNgIdQmaJfP1zifG9hjGnhQgs0ooOfcYPO4ByxWgNoUsBQFj83YUnzEeHgEIj4pR++ZwTZIB3k+VwUk6dQkX06ChxlbhgR/uInRCKXYn3cDNSeY94BZxE8oRXF+nQ1lKMiec5VdVoGGuAdx2he/qKFF5nEFsY5R52SME4ltLtG0fxVDtJJnGuNynC9yX2yRpEdZlg+rwtK0YMxi1J8JLjYR3fJZKfqPlJt5NCPmMK6dCi7+Irrks3bgO1bHNsQd/rEM1DrCd7hAq7J8K9dX/SCWYhXjrhNYrClHc6X2eMZvSTLPDsZFR/AuXdRqgHxkxjbILfJ8d4IeiJLc1iQ/osFp+inw7lTgBI/k8z4OnKHAWEXTKXa3V6W1EYy2ioMzChiPBqeYwngcihSWz6hyfCg3WYo+4EXZA08p4Ekc+BngAT43eFNsKNWuJWxcv3mKMYyYUI7X5br/lD5+G/Z7tKsAAAAASUVORK5CYII=);
    }

    &.half-full {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEmklEQVRoQ+2ZTWxUVRiGn/e2pcytiDJ3ytxZ6EIxMSFE0aDigghu/EEiKiqJP5E405KgMTG6UUMUFq6MkhhbQyDGYGyUBFDYANGFiMa/EBIXxYUuaEEkEYQiwnzmtkwzrTPTc2amWBLObuZ85/2+5773/MwZcYk3XeL1cxng/3Zw0hywPG0ErBhYN6Q4PX2LpOJkwE4mQB/wyMD6U0hsiqOOZy4ZAMtzG7A/KTgBSFog3Z6Nwm+aDTEpDliBzzHuLQcQ7IwzHfdNeQDr5hbO812p0JIDFz7fmst0fN9MiKY7YHm2AQ9UApC0PY7CZVMWwFZzE+f4sbzAcQ7Q2tp2c+fV035qFkRTHbACn2IsrwUgaWschQ9NOQDrYi5FDsDY3X28A5JMQcu87Kz2g82AaJoDVuBjjBXjixoPkPQL9cWZ8NEpA2CruZHzHMQInACkotEyNxe1/9woRMMO2FoCBthRWvddAEZcYGc2Cpc2esTwBrCXmMEJrgfmYNwALMVYUO1JVnqFSrGSvjW0XbL+lqC1X+faDmUyOunjSkUAe5EOTl4oMil0pNg5iOsxsj4JagFU0hEMGjqUQImg32T9QdDab1e1HcpKI+eSsjYGwF4gxWneBx6v9D77FF5lJ65HYnhMsnoBO5ROrSwHGQuQpxt4t+4sFQb6OuCQuzuX6Xhv9DUsH2BdFCgy2ukgNmFI0wEUPJGLUh9WBlhDO2fZg3HnhJU5BjQXQF/FUWqRpPMVAZIvbTVXcI7PgEWONdYMaxaA0JctUer+TumvqpO41GF5Qhg+Vd7dKERTAMTuOB0uk3S65io0Zj6sZTqH2Qrc0whEowCCXdkoXC7pTJVlt3p5tpZpDNCHUfcZviEAaVucTq2QdLZalRPuxMO3C2ILxsP1OFEvgKRPsunUSkn/1Mo7IcDwxO6jhd18AKz0hagLQNoSp1NPlq82dTswOrFHDm0bMZ72gfAFkNicTYerXA95Tg6MQow48QMwzxXCB0BwIBuF812efNV9YKLCrEAPRn6iuFK/DwDQm8t0FFy1kzgvB4bnQ9mdj0siH4B67o78AfL8ClzjUnwS4wOA9FsuCq911fZ2wNZwJX/zp08CLwCgPQhnptM64ZrDywErcAfGPldxbweAlkALZ6fDr11z+AF08SxFel3F6wEIgiCfTaeSH1VOzQ8gz9vAc07KF4J8XyGkd3JR+LxrDj+AwvBvhcWu4vU4IGlvHIVLXHP4AhzB6HQU34foGVw/hCWLr9lCl3GCo3GmY7ZLrNcqZF10UuSIg/ABxCvqYUd57ODvp5YarDOHXTyYHs7OztBRh1zuG5l1sZgie2qI/gK8Rg8fSSQ3CP9pZhYcOTb0mMHrhl1XTStQsCQbpfY2FyDPU8DmCqKHEW9gbFQvNY++pbFm1jZw7HRyYHvVzHLjNX1WIuc5YF0soEj5f1zHCXiTFBv0FkMuT2t8jJmlBv8YWmPYyxizSv0iuCvOpL5w0XQGSMSswCqMBxH7MTao129XrlbQ8eM282zxTLdh85F2xenUJpfivSaxq+DFjvNy4GIX55LvMoDLU5rMmH8BqJNyQP1+HkkAAAAASUVORK5CYII=);
    }

    & + span {
      margin-left: ptrd(2);
    }
  }
  em {
    display: inline-block;
    font-size: ptrd(24);
    color: #ff6600;
    // font-weight: bold;
    vertical-align: middle;
    margin-left: ptrd(6);
    @extend %font-number;
  }
}
</style>
